/**
 * GA4 Event Tracking Utilities
 * Provides functions to track user interactions with Google Analytics 4
 */

// Extend Window interface to include gtag
declare global {
  interface Window {
    gtag?: (
      command: string,
      eventName: string,
      eventParams?: Record<string, any>
    ) => void;
  }
}

/**
 * Track phone number clicks
 * @param phoneNumber - The phone number that was clicked (formatted for display)
 */
export const trackPhoneClick = (phoneNumber: string): void => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "phone_click", {
      event_category: "Contact",
      event_label: phoneNumber,
      value: 1,
    });
    console.log("GA4 Event: phone_click", phoneNumber);
  }
};

/**
 * Track address/map link clicks
 * @param address - The address that was clicked
 * @param location - Optional location identifier (e.g., "main_clinic", "branch")
 */
export const trackMapClick = (address: string, location?: string): void => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "map_click", {
      event_category: "Contact",
      event_label: address,
      location: location || "unknown",
      value: 1,
    });
    console.log("GA4 Event: map_click", address, location);
  }
};

/**
 * Track email clicks
 * @param email - The email address that was clicked
 */
export const trackEmailClick = (email: string): void => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "email_click", {
      event_category: "Contact",
      event_label: email,
      value: 1,
    });
    console.log("GA4 Event: email_click", email);
  }
};

/**
 * Track appointment button clicks
 * @param source - Where the button was clicked from (e.g., "navbar", "cta", "footer")
 */
export const trackAppointmentClick = (source: string): void => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "appointment_click", {
      event_category: "Conversion",
      event_label: source,
      value: 1,
    });
    console.log("GA4 Event: appointment_click", source);
  }
};
